import {
  BASE_ARTICLE_45,
  BASE_MANAGEMENT_AGREEMENT,
} from 'src/app/_services/constants/base-contracts-info';
import { ContractToSignInfo } from 'src/app/_services/types/contract-template.types';
import {
  BusinessRetirementPlan,
  getBusinessRetirementPlanLabel,
} from 'src/app/enums/business/business-retirement-plan.enum';
import { ContractType } from 'src/app/enums/contract-type.enum';
import { InsuranceTypeEnum } from 'src/app/enums/insurance-type.enum';
import { SexEnum } from 'src/app/enums/sex.enum';
import { SelectElement } from 'src/app/ui-kit/components/select/select.component';

import { BUSINESS_INSURANCE_BASE } from '../company-insurance-constants';

export const BUSINESS_RETIREMENT_INSURANCE_BASE = 'lpp';

export const BUSINESS_RETIREMENT_FORM_BASE = `${BUSINESS_INSURANCE_BASE}/${BUSINESS_RETIREMENT_INSURANCE_BASE}`;

export const CONTRACTS_TO_SIGN: ContractToSignInfo[] = [
  {
    ...BASE_ARTICLE_45,
    name: 'Article 45 LPP',
    type: ContractType.ARTICLE_45,
    insuranceType: InsuranceTypeEnum.BUSINESS_RETIREMENT,
  },
  {
    ...BASE_MANAGEMENT_AGREEMENT,
    name: 'Mandat gestion LPP',
    type: ContractType.MANAGEMENT_AGREEMENT,
    insuranceType: InsuranceTypeEnum.BUSINESS_RETIREMENT,
  },
];

// Select options for retirement plans
export const RETIREMENT_PLAN_OPTIONS: SelectElement<BusinessRetirementPlan>[] = [
  {
    value: BusinessRetirementPlan.BASIC,
    label: getBusinessRetirementPlanLabel(BusinessRetirementPlan.BASIC),
  },
  {
    value: BusinessRetirementPlan.IMPROVED,
    label: getBusinessRetirementPlanLabel(BusinessRetirementPlan.IMPROVED),
  },
  {
    value: BusinessRetirementPlan.CUSTOM,
    label: getBusinessRetirementPlanLabel(BusinessRetirementPlan.CUSTOM),
  },
];

// Select options for gender
export const GENDER_OPTIONS: SelectElement<SexEnum>[] = [
  { value: SexEnum.MALE, label: 'Homme' },
  { value: SexEnum.FEMALE, label: 'Femme' },
];
